import React, { Component } from "react";
import { VillageScreenBody, thingDataList, AntdPopoverStyle, datalist, MarkerIcom } from "./style";
import { colorPalette, chartStyle, pieChartColor, pieChartColor2 } from "../../color-palette";
import { ScreenCard, ResourceCard, McLineChart, McBarChart, SingleBarChart, RadarChart, DoubleBarChart,
  PieChartRight, RadioSelectSimple, InputTimeline } from "../../components";
import { MapGL, MapPosition, MapGLProps } from "@gago-react-gl/gago-react-gl";
import { ZengChengMapLayer, zcMapDefault } from "../../containers/map-layer";
import resourceArea from "./images/area.svg";
import resourceGreen from "./images/green.svg";
import resourceLight from "./images/light.svg";
import { chart1N2D } from "../big-screen/style";
import { PlayerModal } from "./modal";
import VillageScreenProvider, { greenLightTrendITable, greenLightContrastITable } from "../../network/providers/village-screen.provider";
import { message, Popover, Checkbox, Tooltip } from "antd";
import { DeviceType, GreenLightType, GreenLightTrend, GreenLightContrast, DeviceDistributionCount, DeviceIndustrialPark,
  DeviceDistribution } from "../../models/village-screen";
import { ITable, Icon } from "@gago/frame";
import turfBbox from "@turf/bbox";
import { GreeningTypeLayer, LightTypeLayer, ZengCengBaseMapLayer } from "./map-layer";
import { RouteComponentProps } from "react-router-dom";
// tslint:disable:naming-convention jsx-no-lambda ter-max-len jsx-no-multiline-js variable-name no-collapsible-if

const CheckboxGroup = Checkbox.Group;

type Vprops = {} & RouteComponentProps;
interface Vstate {
  /** 行政code */
  townCode: string;
  /** 行政name */
  townName?: string;
  /** 定义map实例 */
  mapBaseGL: mapboxgl.Map;
  /** 地图类型选择 */
  mapTypeSelect: string;
  /** 物联网类型选择 */
  selectDeviceType: number[];
  /** 物联网类型列表 */
  deviceType: DeviceType[];
  /** 获取万企帮村数据 */
  helpVillage: ITable<1, 2> | null;
  /** 资源概况 */
  resourceType: GreenLightType | null;
  /** 获取绿光面积及夜光趋势数据 lenYear 获取年份 */
  greenLightTrend: GreenLightTrend[];
  /** 绿化面积及灯光数据各乡镇对比 year 获取年份 */
  greenLightContrast: GreenLightContrast[];
  /** 农村人居环境 */
  livingEnvi: ITable<1, 1> | null;
  /** 省新农村连片示范建设 */
  constructionData: ITable<1, 1> | null;
  /** 获取对应传感器类型的数据 */
  deviceTypeData: ITable<2, 1> | null;
  /** 选择年份 */
  selectYear: string;
  /** 乡镇位点数量 */
  townThingList: DeviceDistributionCount[];
  /** 产业园位点数据 */
  deviceIndustrial: DeviceIndustrialPark[];
  /** 设备点位置信息 */
  deviceDistribution: DeviceDistribution[];
  /** 指定农场的信息 */
  farmDetail: DeviceIndustrialPark | null;
  /** 指定设备点的信息 */
  equipmentPoint: DeviceDistribution | null;
  /** 存储乡镇四至点 */
  townSite: mapboxgl.LngLatBoundsLike;
}

/**
 * 农村遥感监测 --- 物联网大屏
 * @author 马俊峰
 * @date 2020-07-30
 * @class VillageScreen
 * @extends {Component<Vprops, Vstate>}
 */
class VillageScreen extends Component<Vprops, Vstate> {
  /** 地图交互图层事件 */
  baseMapStatus = true;
  playerModal: PlayerModal | null = null;
  state: Vstate = {
    townCode: "",
    townName: undefined,
    mapBaseGL: undefined as unknown as mapboxgl.Map,
    mapTypeSelect: "乡村绿化",
    selectDeviceType: [],
    deviceType: [],
    helpVillage: null,
    resourceType: null,
    greenLightTrend: [],
    greenLightContrast: [],
    livingEnvi: null,
    constructionData: null,
    deviceTypeData: null,
    selectYear: "2019",
    townThingList: [],
    deviceIndustrial: [],
    deviceDistribution: [],
    farmDetail: null,
    equipmentPoint: null,
    townSite: [] as unknown as mapboxgl.LngLatBoundsLike,
  };
  /** 页面初始化加载 */
  initLodaData = async () => {
    const deviceType = await VillageScreenProvider.getDeviceType().catch(err => { message.info("物联网类型数据获取失败！", 1); return [] as DeviceType[]; });
    const helpVillage = await VillageScreenProvider.getHelpVillage().catch(err => { message.info("万企帮数据获取失败！", 1); return null; });
    const selectDeviceType = deviceType.map(item => item.deviceCode);
    this.setState({ selectDeviceType, deviceType, helpVillage });
  }
  /** 物联网数据获取类型分布, 增城数据获取 */
  getDeviceDistribution = async () => {
    const deviceDistribution = await VillageScreenProvider.getDeviceDistribution({}).catch(err => { message.info("物联网类型数据获取失败！", 1); return [] as DeviceDistributionCount[]; });
    this.setState({ townThingList: deviceDistribution });
  }
  /** 物联网数据获取类型分布, 乡镇位点获取 */
  getDeviceDistributionIndustrial = async () => {
    const param = { code: this.state.townCode };
    const deviceDistribution = await VillageScreenProvider.getDeviceDistribution(param).catch(err => { message.info("物联网类型数据获取失败！", 1); return [] as DeviceIndustrialPark[]; });
    this.setState({ deviceIndustrial: deviceDistribution });
  }
  /** 物联网数据获取类型分布, 产业园位点获取 */
  getDeviceDistributionPark = async () => {
    const { farmDetail, townCode } = this.state;
    const param = { code: townCode, parkCode: farmDetail?.parkCode };
    const deviceDistribution = await VillageScreenProvider.getDeviceDistribution(param).catch(err => { message.info("物联网类型数据获取失败！", 1); return [] as DeviceDistribution[]; });
    this.setState({ deviceDistribution });
  }
  /** code类型数据加载 */
  codeLoadData = async () => {
    const param = { code: this.state.townCode === "" ? undefined : this.state.townCode };
    const resourceType = await VillageScreenProvider.getResourceType(param).catch(err => { message.info("资源概况数据获取失败！", 1); return null; });
    const greenLightTrend = await VillageScreenProvider.getGreenLightTrend(param).catch(err => { message.info("绿地灯光数据获取失败！", 1); return [] as GreenLightTrend[]; });
    const greenLightContrast = await VillageScreenProvider.getGreenLightContrast(param).catch(err => { message.info("绿化辐射数据获取失败！", 1); return [] as GreenLightContrast[]; });
    const livingEnvi = await VillageScreenProvider.getLivingEnvi(param).catch(err => { message.info("人居环境数据获取失败！", 1); return null; });
    const constructionData = await VillageScreenProvider.getConstructionData(param).catch(err => { message.info("示范建设数据获取失败！", 1); return null; });
    this.setState({ resourceType, greenLightTrend, greenLightContrast, livingEnvi, constructionData });
  }
  /** 物联网监测数据获取 */
  getDeviceTypeData = async () => {
    const param = { code: this.state.townCode === "" ? undefined : this.state.townCode, types: JSON.stringify(this.state.selectDeviceType) };
    const deviceTypeData = await VillageScreenProvider.getDeviceTypeData(param).catch(err => { message.info("传感器数据获取失败！", 1); return null; });
    this.setState({ deviceTypeData });
  }
  /** 改变code，查找数据 */
  codeChangeData = async () => {
    await this.codeLoadData();
    await this.getDeviceTypeData();
  }
  async componentDidMount() {
    await this.initLodaData();
    await this.codeChangeData();
    await this.getDeviceDistribution();
  }
  /** 地图加载完毕获取实例 */
  mapOnLoad: MapGLProps["onLoad"] = (map) => {
    this.setState({ mapBaseGL: map.target });
  }
  // tslint:disable-next-line:cyclomatic-complexity
  render() {
    const { townCode, townName, mapTypeSelect, helpVillage, resourceType, greenLightTrend, greenLightContrast, livingEnvi, constructionData, deviceTypeData,
            farmDetail } = this.state;
    return(
      <VillageScreenBody colorPalette={colorPalette}>
        <AntdPopoverStyle colorPalette={colorPalette} />
        <div className="header-box" />
        <div className="village-body">
          <div className="asider-left">
            <ScreenCard className="chart-box h-128" colorPalette={colorPalette} title="乡村振兴概况">
              <div className="resource-box">
                <ResourceCard
                  className="resource-single"
                  style={{ backgroundImage: `url(${resourceArea})` }}
                  colorPalette={colorPalette}
                  data={resourceType && resourceType.area || 0}
                  title="总面积"
                  suffix="万亩"
                />
                <ResourceCard
                  className="resource-single"
                  style={{ backgroundImage: `url(${resourceGreen})` }}
                  colorPalette={colorPalette}
                  data={resourceType && resourceType.greenArea || 0}
                  title="绿化面积"
                  suffix="万亩"
                />
                <ResourceCard
                  className="resource-single"
                  style={{ backgroundImage: `url(${resourceLight})` }}
                  colorPalette={colorPalette}
                  data={resourceType && resourceType.lightSum || 0}
                  title="灯光辐射亮度"
                  suffix="LUM"
                />
              </div>
            </ScreenCard>
            <ScreenCard className="chart-box h-196" colorPalette={colorPalette} title="绿化面积趋势">
              {greenLightTrend.length > 0 && <McLineChart
                chartData={greenLightTrendITable(greenLightTrend)}
                showSmooth={false}
                showSymbol={false}
                chartStyle={chartStyle}
                ySplitNumber={3}
                colorPalette={pieChartColor}
              />}
            </ScreenCard>
            <ScreenCard className="chart-box h-196" colorPalette={colorPalette} title="各乡镇绿化率对比">
              {greenLightContrast.length > 0 && <McBarChart
                chartHighLight={townName}
                chartData={greenLightContrastITable(greenLightContrast)}
                chartStyle={chartStyle}
                ySplitNumber={3}
                colorPalette={pieChartColor}
              />}
            </ScreenCard>
            <ScreenCard className="chart-box h-196" colorPalette={colorPalette} title="乡村灯光辐射亮度趋势">
              {greenLightTrend.length > 0 && <McLineChart
                chartData={greenLightTrendITable(greenLightTrend, "灯光辐射")}
                showSmooth={false}
                showSymbol={false}
                chartStyle={chartStyle}
                ySplitNumber={3}
                colorPalette={pieChartColor2}
              />}
            </ScreenCard>
            <ScreenCard className="chart-box h-196" colorPalette={colorPalette} title="各乡镇灯光辐射对比">
              {greenLightContrast.length > 0 && <McBarChart
                chartHighLight={townName}
                chartData={greenLightContrastITable(greenLightContrast, "灯光辐射")}
                chartStyle={chartStyle}
                ySplitNumber={3}
                colorPalette={pieChartColor2}
              />}
            </ScreenCard>
          </div>
          <div className="content-middle">
            <div className="mapbox-border">
              <RadioSelectSimple
                className="cmb-select"
                colorPalette={colorPalette}
                data={thingDataList}
                defaultValue="乡村绿化"
                backSelectChange={this.mapTypeChange}
              />
              {townCode !== "" && (farmDetail === null ? <div className="back-box" onClick={this.mapBackClick}>
                <Icon>rollback</Icon>
                <span className="back-value">返回</span>
              </div> : <div className="back-box" onClick={this.mapBackToLevelClick}>
                <Icon>rollback</Icon>
                <span className="back-value">上一级</span>
              </div>)}
              <div className="map-border">
                <MapGL {...zcMapDefault} onLoad={this.mapOnLoad}>
                  <MapPosition bbox={[[113.55, 23.05], [114, 23.65]]} moveMethod="jumpTo" />
                  {this.mapBaseLayerRender()}
                  {mapTypeSelect === "物联网" && <ZengCengBaseMapLayer />}
                  <ZengChengMapLayer
                    id="village_outline_layer"
                    townCode={townCode}
                    beforeLayer="village_floating_layer"
                    callbackLayer={this.shanDongMapLayerClick}
                  />
                </MapGL>
              </div>
              {mapTypeSelect !== "物联网" && <div className="timeline-box">
                <InputTimeline
                  data={datalist}
                  defaultSelect={4}
                  onChange={this.timelineChange}
                  colorPalette={colorPalette}
                />
              </div>}
            </div>
            {/* <ScreenCard className="chart-box internet-thing-chart" colorPalette={colorPalette} title="物联网监测">
              <div className="internet-thing">
                <div className="it-left-box">
                  <span className="itlb-value">
                    <span className="itlb-f">共：</span>
                    <span className="itlb-s">{deviceTypeData && deviceTypeData.title || "0"}</span>
                    <span className="itlb-t">台</span>
                  </span>
                  <Popover
                    content={this.popoverThingRender()}
                    title={false}
                    trigger="click"
                    placement="top"
                    arrowPointAtCenter
                    overlayClassName="antd-thing-popover"
                  >
                    <span className="itlb-filter" />
                  </Popover>
                </div>
                <div className="it-right-box">
                  <span className="irb-button" onClick={this.thingCenterClick}>物联网监控中心</span>
                  <span className="irb-button" onClick={this.goToVideoList}>监控大屏</span>
                </div>
              </div>
              {deviceTypeData && <SingleBarChart
                chartData={deviceTypeData}
                chartStyle={chartStyle}
                ySplitNumber={3}
                colorPalette={pieChartColor}
              />}
            </ScreenCard> */}
          </div>
          <div className="asider-left">
            <ScreenCard className="chart-box right-height" colorPalette={colorPalette} title="农村人居环境">
              {livingEnvi && <RadarChart
                chartStyle={chartStyle}
                chartData={livingEnvi}
                colorPalette={pieChartColor}
              />}
            </ScreenCard>
            <ScreenCard className="chart-box right-height" colorPalette={colorPalette} title="万企帮万村">
              {helpVillage && <DoubleBarChart
                barWidth={10}
                barGap={-0.3}
                chartHighLight={townName}
                chartStyle={chartStyle}
                colorPalette={{ ...colorPalette, subColor: ["#00fdff", "#ff7b2f"] }}
                chartData={helpVillage}
              />}
            </ScreenCard>
            <ScreenCard className="chart-box right-height" colorPalette={colorPalette} title="省新农村连片示范建设">
              {constructionData && <PieChartRight
                legendShowPercent={false}
                chartData={constructionData}
                chartStyle={chartStyle}
                colorPalette={pieChartColor}
              />}
            </ScreenCard>
            <ScreenCard className="chart-box right-height" colorPalette={colorPalette} title="乡村旅游">
              <DoubleBarChart
                barWidth={10}
                barGap={-0.3}
                chartHighLight={townName}
                chartStyle={chartStyle}
                colorPalette={{ ...colorPalette, subColor: ["#00fdff", "#ff7b2f"] }}
                chartData={chart1N2D}
              />
            </ScreenCard>
          </div>
        </div>
        <PlayerModal onRef={el => this.playerModal = el} colorPalette={colorPalette} />
      </VillageScreenBody>
    );
  }
  /** 地图底层图层事件 */
  mapBackClick = () => {
    const { mapBaseGL } = this.state;
    if (mapBaseGL && mapBaseGL.fitBounds) { mapBaseGL.fitBounds([[113.55, 23.05], [114, 23.65]]); }
    this.setState({ townCode: "", townName: undefined }, this.codeChangeData);
  }
  /** 地图返回上一层级，事件 */
  mapBackToLevelClick = () => {
    const { mapBaseGL, townSite } = this.state;
    if (mapBaseGL && mapBaseGL.fitBounds) { mapBaseGL.fitBounds(townSite); }
    this.setState({ farmDetail: null, deviceDistribution: [] });
  }
  /** 增城区农事地块点击事件 */
  shanDongMapLayerClick = (properties: any, geometry: any) => {
    window.setTimeout(() => {
      if (!this.baseMapStatus) { this.baseMapStatus = true; return; }
      const { town, town_code } = properties;
      const { mapBaseGL } = this.state;
      const bbox = turfBbox(geometry) as unknown as mapboxgl.LngLatBoundsLike;
      if (mapBaseGL && mapBaseGL.fitBounds) { mapBaseGL.fitBounds(bbox); }
      this.setState({ townCode: town_code, townName: town, townSite: bbox }, async () => {
        await this.codeChangeData();
        await this.getDeviceDistributionIndustrial();
      });
    }, 300);
  }
  /** 地图类型返回数据 */
  mapTypeChange = (type: string) => {
    this.setState({ mapTypeSelect: type });
  }
  /** 时间轴改变事件 */
  timelineChange = async (date: string) => {
    this.setState({ selectYear: date });
  }
  /** 地图图层逻辑dom输出 */
  mapBaseLayerRender = () => {
    const { mapTypeSelect, selectYear, townCode, townThingList, deviceIndustrial, farmDetail, deviceDistribution } = this.state;
    if (mapTypeSelect === "乡村绿化") { return <GreeningTypeLayer date={selectYear} />; }
    if (mapTypeSelect === "乡村灯光") { return <LightTypeLayer date={selectYear} />; }
    // tslint:disable:early-exit jsx-wrap-multiline no-unnecessary-else
    if (mapTypeSelect === "物联网") {
      if (townCode === "") {
        return <>
          {townThingList.map((item, index) => {
            if (item.count > 0) {
              return <MarkerIcom key={index} coordinates={item.center.coordinates} colorPalette={colorPalette}>
                <div className="maker-box">
                  <div className="icon-box">{item.count}</div>
                </div>
              </MarkerIcom>;
            }
          })}
        </>;
      } else if (farmDetail !== null) {
        return <>
          {deviceDistribution.map((item, index) => (
            <MarkerIcom key={index} coordinates={item.center.coordinates} colorPalette={colorPalette}>
              <div className="equipment-point">
                <Tooltip
                  overlayClassName="antecedent-tooltip"
                  placement="top"
                  arrowPointAtCenter
                  title={this.equipmentPointDetail(item)}
                >
                  <div className="equipment-point-icon" onClick={this.equipmentPointClick.bind(this, item)} />
                </Tooltip>
              </div>
            </MarkerIcom>
          ))}
        </>;
      } else {
        return <>
          {deviceIndustrial.map((item, index) => (
            <MarkerIcom key={index} coordinates={item.center.coordinates} colorPalette={colorPalette}>
              <div className="massif-maker-box">
                <Tooltip
                  overlayClassName="antecedent-tooltip"
                  placement="top"
                  arrowPointAtCenter
                  title={this.enterpriseInfoDetail(item)}
                >
                  <div className="massid-spot" onClick={this.farmPointClick.bind(this, item)} />
                </Tooltip>
              </div>
            </MarkerIcom>
          ))}
        </>;
      }
    }
  }
  /** 生成地块信息实例dom */
  enterpriseInfoDetail = (mapData: DeviceIndustrialPark) => {
    return (
      <div className="prise-info-box">
        <div className="title-box-tool">
          <span className="tool-tb-name">名称：</span>
          <span className="tool-tb-value">{mapData.parkName}</span>
        </div>
        {mapData.imageUrl && <div className="video-box">
          <img src={`${window.config.publisher}/api/v1${mapData.imageUrl}`} alt="" className="carous-img"/>
        </div>}
      </div>
    );
  }
  /** 生产设备点位点详细信息 */
  equipmentPointDetail = (data: DeviceDistribution) => {
    return (
      <div className="prise-info-box">
        <div className="title-box-tool">
          <span className="tool-tb-value">{data.deviceName}</span>
        </div>
      </div>
    );
  }
  /** 物联网类型筛选返回dom */
  popoverThingRender = () => {
    const { selectDeviceType, deviceType } = this.state;
    // tslint:disable-next-line:jsx-wrap-multiline
    return <div className="thing-filter">
      <CheckboxGroup
        options={deviceType.map(item => ({ label: item.deviceName, value: item.deviceCode }))}
        value={selectDeviceType}
        onChange={this.onThingFilterChange}
      />
    </div>;
  }
  /** 物联网农场图标点击事件 */
  farmPointClick = (data: DeviceIndustrialPark) => {
    this.baseMapStatus = false;
    const { mapBaseGL } = this.state;
    if (mapBaseGL && mapBaseGL.fitBounds) {
      const boundsBbox = data.bounds as unknown as mapboxgl.LngLatBoundsLike;
      mapBaseGL.fitBounds(boundsBbox);
    }
    this.setState({ farmDetail: data }, this.getDeviceDistributionPark);
  }
  /** 设备点选择事件 */
  equipmentPointClick = (data: DeviceDistribution) => {
    this.baseMapStatus = false;
    // this.playerModal && this.playerModal.openModal();
  }
  /** 物联网筛选过滤事件 */
  onThingFilterChange = (checked: any[]) => {
    this.setState({ selectDeviceType: checked }, this.getDeviceTypeData);
  }
  /** 物联网监控中心 */
  thingCenterClick = () => {
    message.info("正在开发...");
  }
  /** 进入视频监控列表页面 */
  goToVideoList = () => {
    message.info("正在开发...");
    // this.props.history.replace("/video-list");
  }
}
// tslint:disable-next-line:max-file-line-count
export default VillageScreen;
